<template>
    <div>
        <feather-icon icon="EditIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord"/>
        <feather-icon icon="TrashIcon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
                      @click="confirmDeleteRecord"/>
    </div>
</template>

<script>
export default {
    name: 'CellRendererActions',
    methods: {
        assignDevice() {
            // if (this.params.data.employeeId) {
            //   return this.$vs.dialog({
            //     color: 'danger',
            //     title: `Lỗi`,
            //     text: `Thiết bị đã cấp phát. Xin thu hồi trước khi cấp phát lại`,
            //     acceptText: "Đồng ý"
            //   })
            // }
        },
        editRecord() {
            this.$router.push(`/user/edit-daily-work?branch_id=${this.params.data.organizationBranchId}&id=${this.params.data.id}`).catch((err
            ) => {
            })
        },
        confirmDeleteRecord() {

            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận xoá`,
                text: `Bạn có chắc là muốn xoá`,
                accept: this.deleteRecord,
                acceptText: "Xoá",
                cancelText: "Huỷ"
            })
        },
        deleteRecord() {
            this.$vs.loading();
            this.$crm.post('/daily-work/employee/delete/' + this.params.data.id).then(() => {
                this.$vs.loading.close();
                this.showDeleteSuccess();
                this.$store.commit('UPDATE_EMPLOYEE', true);
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        showDeleteSuccess() {
            this.$vs.notify({
                color: 'success',
                text: 'Xoá thành công',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
            })
        },
        confirmRevoke() {
            if (!this.params.data.employeeId) {
                return this.$vs.dialog({
                    color: 'danger',
                    title: `Lỗi`,
                    text: `Không thể thu hồi thiết bị chưa cấp phát`,
                    acceptText: "Đồng ý"
                })
            }
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận thu hồi`,
                text: `Bạn có chắc là muốn thu hồi`,
                accept: this.revokeDevice,
                acceptText: "Xác nhận",
                cancelText: "Huỷ"
            })
        },
        revokeDevice() {
            this.$vs.loading();
            this.$crm.post('/device/revoke/' + this.params.data.id).then(() => {
                this.$vs.loading.close();
                this.showRevokeSuccess();
                this.$store.commit('UPDATE_DEVICE', true);
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        showRevokeSuccess() {
            this.$vs.notify({
                color: 'success',
                text: 'Thu hồi thành công',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
            })
        }
    }
}
</script>
